import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "left-parenthesis",
  "use": "left-parenthesis-usage",
  "viewBox": "0 0 19 30",
  "content": "<symbol viewBox=\"0 0 19 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left-parenthesis\"><path d=\"M19 0h-3.994C6.716 0 0 6.716 0 15c0 8.286 6.719 15 15.006 15H19c-5.354-2.863-8.996-8.505-8.996-15 0-6.494 3.642-12.137 8.996-15z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/left-parenthesis.svg
// module id = 592
// module chunks = 0